"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShowLessButton = void 0;
var ShowLessButton_1 = require("./ShowLessButton");
Object.defineProperty(exports, "ShowLessButton", { enumerable: true, get: function () { return ShowLessButton_1.ShowLessButton; } });
//# sourceMappingURL=index.js.map